// extracted by mini-css-extract-plugin
export default {"optionName":"tqx_MadzYUm4BobjoB_i","optionsMore":"oAdmmPMEyw4M8JjqE_Zn","delimiter":"_cmePwJCCTPdrfeXo6Nn"};